if (!customElements.get('adelaide-faq')) {
  customElements.define('adelaide-faq', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.buttons = [...this.querySelectorAll('[data-faq-topic]')];
      this.questions = [...this.querySelectorAll('[data-faq-group]')];
      this.questionContainer = this.querySelector('.adelaide-faq__questions');
      this.questions.forEach((question) => {
        question.addEventListener('toggle', () => {
          if (!question.open) return;
          this.questions.forEach((other) => {
            if (other !== question) other.open = false;
          });
        }, options);
      });
      this.buttons.forEach(button => {
        button.hidden = !this.questions.some(question => question.dataset.faqGroup === button.dataset.faqTopic);
        button.addEventListener('click', () => this.selectTopic(button.dataset.faqTopic, true), options);
      });
      this.addEventListener('shopify:block:select', event => {
        const question = event.target.closest('[data-faq-group]');
        if (question) {
          this.selectTopic(question.dataset.faqGroup);
          question.open = true;
        }
      }, options);
      const first = this.buttons.find(button => !button.hidden);
      if (first) this.selectTopic(first.dataset.faqTopic);
    }
    selectTopic(topic, animate = false) {
      if (this.activeTopic === topic) return;
      this.activeTopic = topic;
      const container = this.questionContainer;
      const oldHeight = container?.getBoundingClientRect().height;
      this.animations?.forEach(animation => animation.cancel());
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.faqTopic === topic)));
      this.questions.forEach(question => {
        question.hidden = question.dataset.faqGroup !== topic;
        if (question.hidden) question.open = false;
      });
      if (this.questionContainer) {
        const visible = this.questions.filter(question => !question.hidden);
        const split = Math.max(1, Math.floor(visible.length / 2));
        const columns = [document.createElement('div'), document.createElement('div')];
        columns.forEach(column => { column.className = 'adelaide-faq__column'; });
        visible.forEach((question, index) => columns[index < split ? 0 : 1].append(question));
        const hidden = this.questions.filter(question => question.hidden);
        this.questionContainer.replaceChildren(...columns.filter(column => column.children.length), ...hidden);
        if (animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const newHeight = container.getBoundingClientRect().height;
          this.animations = [container.animate(
            [{ height: `${oldHeight}px`, overflow: 'hidden' }, { height: `${newHeight}px`, overflow: 'hidden' }],
            { duration: 280, easing: 'cubic-bezier(.22, 1, .36, 1)' }
          ), ...columns.filter(column => column.children.length).map(column => column.animate(
            [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 240, easing: 'ease-out' }
          ))];
        }
      }
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.animations?.forEach(animation => animation.cancel());
      this.activeTopic = null;
    }
  });
}
